import React, { useEffect, useState } from 'react';
import { Row, Col, Typography, Card } from 'antd';
import {
  DollarOutlined,
  ShoppingOutlined,
  TeamOutlined,
  RobotOutlined,
  ShopOutlined,
  CarOutlined,
} from '@ant-design/icons';
import KPICard from '../../components/KPICard';
import api from '../../config/api';

const { Title } = Typography;

const Dashboard = () => {
  const [kpis, setKpis] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchKPIs = async () => {
      try {
        const { data } = await api.get('/dashboard/kpis');
        setKpis(data.kpis);
      } catch (err) {
        // Use mock data if API fails
        setKpis({
          ventasHoy: { value: 245680, currency: 'MXN', change: 12.5, label: 'Ventas del Día' },
          productosActivos: { value: 4670, change: 2.1, label: 'Productos Activos' },
          empleados: { value: 737, change: 0, label: 'Empleados' },
          botsActivos: { value: 42, total: 46, label: 'Bots Activos' },
          distribuidoras: { value: 15, meta: 250, label: 'Distribuidoras' },
          estaciones: { value: 20, label: 'Gasolineras' },
        });
      } finally {
        setLoading(false);
      }
    };
    fetchKPIs();
  }, []);

  return (
    <div>
      <Title level={3} style={{ marginBottom: 24 }}>
        Dashboard Ejecutivo
      </Title>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={8}>
          <KPICard
            title="Ventas del Día"
            value={kpis?.ventasHoy?.value}
            prefix="$"
            suffix="MXN"
            icon={<DollarOutlined />}
            color="#E8192C"
            change={kpis?.ventasHoy?.change}
            loading={loading}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <KPICard
            title="Productos Activos"
            value={kpis?.productosActivos?.value}
            icon={<ShoppingOutlined />}
            color="#197278"
            change={kpis?.productosActivos?.change}
            loading={loading}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <KPICard
            title="Empleados"
            value={kpis?.empleados?.value}
            icon={<TeamOutlined />}
            color="#6c5ce7"
            loading={loading}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <KPICard
            title="Bots Activos"
            value={kpis?.botsActivos?.value}
            suffix={`/ ${kpis?.botsActivos?.total || 46}`}
            icon={<RobotOutlined />}
            color="#00b894"
            loading={loading}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <KPICard
            title="Distribuidoras"
            value={kpis?.distribuidoras?.value}
            suffix={`/ ${kpis?.distribuidoras?.meta || 250}`}
            icon={<ShopOutlined />}
            color="#fdcb6e"
            loading={loading}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <KPICard
            title="Gasolineras"
            value={kpis?.estaciones?.value}
            icon={<CarOutlined />}
            color="#e17055"
            loading={loading}
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={12}>
          <Card title="Ventas por Empresa" bordered={false} style={{ borderRadius: 8, minHeight: 300 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 200, color: '#999' }}>
              Gráfica de ventas — Fase 2 (conexión con Odoo)
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="Status de Bots IA" bordered={false} style={{ borderRadius: 8, minHeight: 300 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 200, color: '#999' }}>
              Monitor de bots — Fase 3 (conexión con Miguelitro)
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
